import React from 'react';

import { Box, Typography } from '@mui/material';

import { loanPurposeOptions } from 'constants/options';
import { StatusColor, StatusEnum } from 'constants/status';
import { formatLockExpirationDate, getLockExpirationDaysLeft } from 'utils/lockExpiration';
import { formatNumberToCurrencyString, formatNumberToFixed3Decimals } from 'utils/number';

import {
  DollarIcon,
  DrawCreditCardIcon,
  LockIcon,
  NoteIcon,
  UnlockIcon,
} from '../../coreDesignSystem/icons';

import HoverDescriptionItem from './HoverDescriptionItem';
import {
  hoverContentStyles,
  hoverDescriptionListStyles,
  hoverTitleStyles,
} from './LoanInfoCards.styles';

export const getLoanInfoCardsConfig = ({
  loanPurpose,
  loanAmount,
  interestRate,
  lockExpirationDate,
  programName,
}) => {
  const lockExpiration = formatLockExpirationDate(lockExpirationDate);

  return [
    {
      name: 'Purpose',
      value: loanPurposeOptions.find(({ value }) => value === loanPurpose)?.name || 'N/A',
      icon: <NoteIcon />,
      fieldName: 'LoanPurpose',
    },
    {
      name: 'Loan Amount',
      value: formatNumberToCurrencyString(loanAmount, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
      icon: <DollarIcon />,
      fieldName: 'LoanAmount',
    },
    {
      name: 'Rate',
      value: `${formatNumberToFixed3Decimals(interestRate)}%`,
      icon: lockExpirationDate ? <LockIcon /> : <UnlockIcon />,
      iconColor: lockExpirationDate
        ? StatusColor[StatusEnum.SUCCESS]
        : StatusColor[StatusEnum.WARNING],
      hoverContent: (
        <Box sx={hoverContentStyles}>
          <Typography sx={hoverTitleStyles} variant="regular14">
            {lockExpirationDate ? 'Lock' : 'Not Locked'}
          </Typography>
          <Box sx={hoverDescriptionListStyles}>
            <HoverDescriptionItem title="Lock Expiration" value={lockExpiration ?? '-'} />
            <HoverDescriptionItem
              title="Lock Expires"
              value={lockExpiration ? `${getLockExpirationDaysLeft(lockExpirationDate)} Days` : '-'}
            />
          </Box>
        </Box>
      ),
      fieldName: 'Rate',
    },
    {
      name: 'Loan Program',
      value: programName || 'N/A',
      icon: <DrawCreditCardIcon />,
      fieldName: 'LoanProgram',
    },
  ];
};
